function burger_header() {
	let unlock = true;
	//=================
	//Menu
	let iconMenu = document.querySelector(".icon-menu");
	let menuBody = document.querySelector(".burger-wrapper__menu");
	let overlay = document.querySelector(".overlay");
	let menuTriggerClose = document.querySelector(".menu-trigger-close-burger");
	let collectionSidebar = document.querySelector(".mobile-filters-wrapper");
	if (iconMenu != null) {
		let delay = 500;
		let menuBody = document.querySelector(".burger-wrapper__menu");
		iconMenu.addEventListener("click", function (e) {
			if (unlock) {
				overlay.classList.add("active");
				document.body.classList.add('lock');
				iconMenu.classList.toggle("active");
				if(collectionSidebar){
					collectionSidebar.style.position = "initial";
				}
				menuBody.classList.toggle("active");
				menuTriggerClose.classList.remove("active");
			}
		});
		menuTriggerClose.addEventListener("click", function (e) {
      if (unlock) {
				overlay.classList.remove("active");
				document.body.classList.remove('lock');
        menuTriggerClose.classList.toggle("active");
        menuBody.classList.toggle("active");
        iconMenu.classList.remove("active");
      }
    });
	};

	function menu_close() {
		let iconMenu = document.querySelector(".icon-menu");
		let menuBody = document.querySelector(".burger-wrapper__menu");
		iconMenu.classList.remove("active");
		menuBody.classList.remove("active");

	}
}

burger_header();